import { useContext } from "react"
import { Navigate, Route, Routes, useParams } from "react-router-dom"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"
import { WideLayout } from "source/Layout"
import Event from "source/registrations/event"
import Events, {
  UnknownFilterEvents,
  FilteredEvents,
} from "source/registrations/events"
import MyRegistrations from "source/registrations/myRegistrations"
import Registration from "source/registrations/registrations"
import Reservations from "source/registrations/reservations"
import { useOrganizationSetting } from "source/registrations/hooks/useOrganization"

export function Registrations() {
  const { paths } = useContext(ServerRenderedProps)
  const canUseChurchCenterWeb = useOrganizationSetting("churchCenterWeb")
  const canUseChurchCenterWebRegistrations = useOrganizationSetting(
    "churchCenterWebRegistrations",
  )

  if (!canUseChurchCenterWeb) {
    window.location = paths.missing_organization
  }

  if (!canUseChurchCenterWebRegistrations) {
    return <Navigate to="/home" replace />
  }

  return (
    <WideLayout>
      <Routes>
        <Route
          path="/events/:eventId/registrations/new"
          element={<RedirectRegistrationsNew />}
        />
        <Route
          path="/registrations/new"
          element={<RedirectRegistrationsNew />}
        />
        <Route
          path="/registrations/:registrationId"
          element={<RedirectToConfirmation />}
        />
        <Route path="/profile" element={<MyRegistrations />} />
        <Route
          path="/profile_registrations/future"
          element={
            <MyRegistrations.PaginatedRegistrations timeframe="upcoming" />
          }
        />
        <Route
          path="/profile_registrations/ongoing"
          element={
            <MyRegistrations.PaginatedRegistrations timeframe="ongoing" />
          }
        />
        <Route
          path="/profile_registrations/past"
          element={<MyRegistrations.PaginatedRegistrations timeframe="past" />}
        />

        <Route
          path="/signups/:filter/:filterId"
          element={<RedirectSignupsToEvents />}
        />
        <Route
          path="/signups/campus/:campusId/category/:categoryId"
          element={<RedirectSignupsToEvents />}
        />
        <Route path="/signups/:eventId" element={<RedirectSignupsToEvents />} />
        <Route path="/signups" element={<RedirectSignupsToEvents />} />

        <Route
          path="/events/:filter/:filterId"
          element={<UnknownFilterEvents />}
        />
        <Route
          path="/events/campus/:campusId/category/:categoryId"
          element={<FilteredEvents />}
        />
        <Route path="/events/:eventId" element={<Event />} />
        <Route path="/events" element={<Events />} />

        <Route path="*" element={<Events />} />

        <Route
          path="/:eventSignupPath/:eventId/reservations/*"
          element={<Reservations />}
        />
        <Route
          path="/registrations/:registrationId/*"
          element={<Registration />}
        />
      </Routes>
    </WideLayout>
  )
}

function RedirectSignupsToEvents() {
  const redirectedPathname = window.location.pathname.replace(
    "/signups",
    "/events",
  )
  const redirectUrl = `${redirectedPathname}${window.location.search}`
  return <Navigate to={redirectUrl} replace />
}

function RedirectRegistrationsNew() {
  const { eventId } = useParams()
  const redirectUrl = eventId
    ? `/registrations/events/${eventId}/reservations/new${window.location.search}`
    : `/reservations/new${window.location.search}`
  return <Navigate to={redirectUrl} replace />
}

function RedirectToConfirmation() {
  const { registrationId } = useParams()
  return (
    <Navigate
      to={`/registrations/registrations/${registrationId}/confirmation${window.location.search}`}
      replace
    />
  )
}
